var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroSportsDataTrajectories(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1647 989",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "trajectory",
    x1: 823,
    y1: 250,
    x2: 823,
    y2: 940,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168BFF",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#168BFF",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#168BFF",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#trajectory)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "3 8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79 463C65 580 302 708 748 925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 327C79 526 391 733 764 932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 356C358 507 544 718 780 940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497 539C478 650 644 786 794 944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 490C658 618 738 764 808 947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301 368C1331 526 1089 731 840 940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 326C1513 509 1185 723 856 933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495 517C1517 647 1146 806 870 925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165 559C1150 676 1004 790 884 918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095 416C1164 544 1003 730 898 911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 266C737 383 717 608 748 925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 266C755 401 741 643 764 932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 266C781 434 765 692 780 940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 266C802 465 788 728 794 944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 266C822 479 811 746 808 947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 266C846 466 835 728 826 946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 266C870 435 859 691 840 940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 266C894 404 882 642 856 933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 266C917 382 907 608 870 925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 250C332 350 513 422 748 925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422 250C1313 350 1132 422 898 911"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#168BFF",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "3 8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79 463C282 360 579 271 823 266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 327C347 274 608 246 823 266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 356C545 294 683 258 823 266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497 539C591 385 706 286 823 266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 490C735 389 777 301 823 266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301 368C1175 298 1001 255 823 266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 326C1201 272 973 246 823 266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495 517C1309 388 1055 282 823 266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165 559C1076 404 956 286 823 266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095 416C1021 330 920 273 823 266"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#168BFF",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155 327C190 515 438 766 764 932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 356C440 531 598 746 780 940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497 539C543 690 675 811 794 944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095 416C1080 593 971 782 898 911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301 368C1298 550 1075 789 840 940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 326C1372 529 1159 773 856 933"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#168BFF",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "2 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M777 310C768 490 767 704 764 932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790 288C789 498 788 719 780 940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806 277C809 513 807 737 794 944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838 277C835 513 837 737 840 940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854 289C850 498 852 719 856 933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868 310C860 490 861 704 870 925"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#168BFF",
    fillOpacity: 0.2,
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 823,
    cy: 266,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 758,
    cy: 932,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 799,
    cy: 956,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 843,
    cy: 952,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 881,
    cy: 926,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 785,
    cy: 903,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 892,
    r: 14
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#168BFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 823,
    cy: 266,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 463,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 327,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 250,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 356,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497,
    cy: 539,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699,
    cy: 490,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 741,
    cy: 405,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 745,
    cy: 554,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 556,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 902,
    cy: 578,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 958,
    cy: 539,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1014,
    cy: 587,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1095,
    cy: 416,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1165,
    cy: 559,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1301,
    cy: 368,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1390,
    cy: 326,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1422,
    cy: 250,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1495,
    cy: 517,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 734,
    cy: 901,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 758,
    cy: 932,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 785,
    cy: 903,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 799,
    cy: 956,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 822,
    cy: 923,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 843,
    cy: 952,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 857,
    cy: 915,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 881,
    cy: 926,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 892,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 936,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 896,
    cy: 857,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 755,
    cy: 868,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773,
    cy: 890,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 807,
    cy: 882,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 831,
    cy: 902,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870,
    cy: 875,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 902,
    cy: 913,
    r: 3
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    stroke: "#168BFF",
    strokeLinecap: "round",
    strokeDasharray: "2 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706 398V184",
    strokeOpacity: 0.16,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724 370V120",
    strokeOpacity: 0.25,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 432V218",
    strokeOpacity: 0.19,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752 349V74",
    strokeOpacity: 0.31,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767 410V152",
    strokeOpacity: 0.24,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780 365V105",
    strokeOpacity: 0.36,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792 447V244",
    strokeOpacity: 0.18,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 382V58",
    strokeOpacity: 0.42,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814 425V171",
    strokeOpacity: 0.28,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826 361V89",
    strokeOpacity: 0.46,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837 445V230",
    strokeOpacity: 0.21,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848 386V133",
    strokeOpacity: 0.34,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860 416V62",
    strokeOpacity: 0.4,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873 354V112",
    strokeOpacity: 0.3,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886 438V203",
    strokeOpacity: 0.19,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899 376V81",
    strokeOpacity: 0.35,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913 422V166",
    strokeOpacity: 0.25,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927 348V49",
    strokeOpacity: 0.33,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941 402V140",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955 368V96",
    strokeOpacity: 0.24,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969 430V188",
    strokeOpacity: 0.17,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982 384V126",
    strokeOpacity: 0.18,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995 414V214",
    strokeOpacity: 0.13,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008 357V156",
    strokeOpacity: 0.15,
    strokeWidth: 1.5
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#168BFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 398,
    r: 3,
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 184,
    r: 2,
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 724,
    cy: 370,
    r: 4,
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 724,
    cy: 120,
    r: 2.5,
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 739,
    cy: 432,
    r: 2.5,
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 739,
    cy: 218,
    r: 2,
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 752,
    cy: 349,
    r: 4,
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 752,
    cy: 74,
    r: 2.5,
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767,
    cy: 410,
    r: 3,
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767,
    cy: 152,
    r: 2,
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 365,
    r: 4.5,
    fillOpacity: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 105,
    r: 3,
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 792,
    cy: 447,
    r: 2.5,
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 792,
    cy: 244,
    r: 2,
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 803,
    cy: 382,
    r: 5,
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 803,
    cy: 58,
    r: 3,
    fillOpacity: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814,
    cy: 425,
    r: 3.5,
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814,
    cy: 171,
    r: 2,
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 361,
    r: 5,
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 89,
    r: 3.5,
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837,
    cy: 445,
    r: 2.5,
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837,
    cy: 230,
    r: 2,
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 848,
    cy: 386,
    r: 4,
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 848,
    cy: 133,
    r: 2.5,
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 860,
    cy: 416,
    r: 4.5,
    fillOpacity: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 860,
    cy: 62,
    r: 3,
    fillOpacity: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873,
    cy: 354,
    r: 4,
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873,
    cy: 112,
    r: 2.5,
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 886,
    cy: 438,
    r: 2.5,
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 886,
    cy: 203,
    r: 2,
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 899,
    cy: 376,
    r: 4,
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 899,
    cy: 81,
    r: 2.5,
    fillOpacity: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 913,
    cy: 422,
    r: 3,
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 913,
    cy: 166,
    r: 2,
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 927,
    cy: 348,
    r: 4,
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 927,
    cy: 49,
    r: 2.5,
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941,
    cy: 402,
    r: 3,
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941,
    cy: 140,
    r: 2,
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 955,
    cy: 368,
    r: 3.5,
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 955,
    cy: 96,
    r: 2,
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 430,
    r: 2.5,
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 188,
    r: 2,
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 982,
    cy: 384,
    r: 3,
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 982,
    cy: 126,
    r: 2,
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 995,
    cy: 414,
    r: 2.5,
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 995,
    cy: 214,
    r: 1.8,
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1008,
    cy: 357,
    r: 2.5,
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1008,
    cy: 156,
    r: 1.8,
    fillOpacity: 0.28
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    stroke: "#168BFF",
    strokeLinecap: "round",
    strokeDasharray: "2 7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M646 501C642 405 650 318 634 221",
    strokeOpacity: 0.16,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669 462C673 347 663 261 676 144",
    strokeOpacity: 0.23,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688 526C681 430 696 359 684 271",
    strokeOpacity: 0.14,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716 478C723 356 711 286 726 181",
    strokeOpacity: 0.27,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746 503C740 412 751 317 743 226",
    strokeOpacity: 0.18,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774 470C781 352 771 269 780 159",
    strokeOpacity: 0.3,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805 518C800 421 811 339 804 249",
    strokeOpacity: 0.19,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836 487C843 370 831 277 840 172",
    strokeOpacity: 0.34,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867 530C859 434 873 364 865 280",
    strokeOpacity: 0.16,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894 493C901 377 889 296 899 202",
    strokeOpacity: 0.28,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925 516C920 424 931 345 923 257",
    strokeOpacity: 0.18,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952 475C958 363 948 282 958 188",
    strokeOpacity: 0.3,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978 506C973 418 982 337 975 238",
    strokeOpacity: 0.16,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004 465C1011 353 998 277 1009 166",
    strokeOpacity: 0.24,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028 514C1022 430 1034 356 1027 269",
    strokeOpacity: 0.14,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051 481C1058 376 1045 302 1054 209",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069 526C1065 443 1074 375 1068 293",
    strokeOpacity: 0.12,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626 453C632 350 620 273 630 183",
    strokeOpacity: 0.14,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 501C598 416 610 344 602 251",
    strokeOpacity: 0.11,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089 461C1096 366 1084 289 1094 194",
    strokeOpacity: 0.15,
    strokeWidth: 1.5
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#168BFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 646,
    cy: 501,
    r: 2.5,
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 221,
    r: 1.8,
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 462,
    r: 3.5,
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676,
    cy: 144,
    r: 2.2,
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688,
    cy: 526,
    r: 2.2,
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 684,
    cy: 271,
    r: 1.7,
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 716,
    cy: 478,
    r: 3.5,
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 726,
    cy: 181,
    r: 2.4,
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 746,
    cy: 503,
    r: 2.6,
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 743,
    cy: 226,
    r: 1.8,
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 470,
    r: 3.7,
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 159,
    r: 2.6,
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 805,
    cy: 518,
    r: 2.8,
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 804,
    cy: 249,
    r: 1.8,
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 836,
    cy: 487,
    r: 4,
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840,
    cy: 172,
    r: 2.8,
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 867,
    cy: 530,
    r: 2.4,
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 865,
    cy: 280,
    r: 1.7,
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 894,
    cy: 493,
    r: 3.5,
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 899,
    cy: 202,
    r: 2.4,
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 925,
    cy: 516,
    r: 2.7,
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 923,
    cy: 257,
    r: 1.8,
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 475,
    r: 3.7,
    fillOpacity: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 958,
    cy: 188,
    r: 2.5,
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 978,
    cy: 506,
    r: 2.4,
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975,
    cy: 238,
    r: 1.7,
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004,
    cy: 465,
    r: 3.2,
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 166,
    r: 2.1,
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028,
    cy: 514,
    r: 2.2,
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027,
    cy: 269,
    r: 1.6,
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1051,
    cy: 481,
    r: 2.7,
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1054,
    cy: 209,
    r: 1.9,
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 526,
    r: 2,
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1068,
    cy: 293,
    r: 1.5,
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 453,
    r: 2.3,
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 630,
    cy: 183,
    r: 1.7,
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 603,
    cy: 501,
    r: 2,
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 251,
    r: 1.5,
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 461,
    r: 2.4,
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1094,
    cy: 194,
    r: 1.7,
    fillOpacity: 0.24
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    stroke: "#168BFF",
    strokeLinecap: "round",
    strokeDasharray: "2 7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M690 679C687 758 693 825 689 904",
    strokeOpacity: 0.16,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709 638C714 737 704 831 711 930",
    strokeOpacity: 0.28,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728 706C724 778 731 841 727 914",
    strokeOpacity: 0.18,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 654C753 750 743 840 750 940",
    strokeOpacity: 0.35,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766 721C762 794 770 859 766 930",
    strokeOpacity: 0.22,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783 670C789 760 779 854 786 948",
    strokeOpacity: 0.42,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 698C797 780 803 862 799 951",
    strokeOpacity: 0.34,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817 646C823 747 813 847 820 943",
    strokeOpacity: 0.46,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 714C831 790 839 859 835 933",
    strokeOpacity: 0.25,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853 662C859 756 849 851 856 941",
    strokeOpacity: 0.4,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871 705C867 785 875 855 871 925",
    strokeOpacity: 0.22,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889 632C895 732 885 838 892 936",
    strokeOpacity: 0.33,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908 688C904 772 912 844 908 921",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927 651C933 750 923 838 930 930",
    strokeOpacity: 0.29,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946 711C942 786 950 848 946 913",
    strokeOpacity: 0.16,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670 730C666 794 673 850 669 905",
    strokeOpacity: 0.12,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965 694C970 773 961 846 967 922",
    strokeOpacity: 0.16,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 612C736 723 725 829 732 925",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871 600C877 714 866 823 873 930",
    strokeOpacity: 0.26,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913 620C919 722 908 823 915 910",
    strokeOpacity: 0.18,
    strokeWidth: 1.5
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#168BFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 679,
    r: 2.5,
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 904,
    r: 1.8,
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 638,
    r: 3.5,
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 711,
    cy: 930,
    r: 2.4,
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728,
    cy: 706,
    r: 2.7,
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 727,
    cy: 914,
    r: 1.8,
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 747,
    cy: 654,
    r: 4,
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 940,
    r: 2.8,
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 766,
    cy: 721,
    r: 3,
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 766,
    cy: 930,
    r: 2,
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783,
    cy: 670,
    r: 4.5,
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 948,
    r: 3.2,
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 698,
    r: 4,
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 799,
    cy: 951,
    r: 2.8,
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817,
    cy: 646,
    r: 5,
    fillOpacity: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 943,
    r: 3.5,
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835,
    cy: 714,
    r: 3,
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835,
    cy: 933,
    r: 2,
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853,
    cy: 662,
    r: 4.5,
    fillOpacity: 0.88
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 941,
    r: 3.2,
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 871,
    cy: 705,
    r: 3,
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 871,
    cy: 925,
    r: 2,
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 632,
    r: 4,
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 936,
    r: 2.8,
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908,
    cy: 688,
    r: 2.8,
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908,
    cy: 921,
    r: 2,
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 927,
    cy: 651,
    r: 3.5,
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 930,
    r: 2.4,
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 711,
    r: 2.5,
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 913,
    r: 1.8,
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 670,
    cy: 730,
    r: 2,
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 905,
    r: 1.5,
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 965,
    cy: 694,
    r: 2.4,
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 967,
    cy: 922,
    r: 1.7,
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 612,
    r: 2.8,
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732,
    cy: 925,
    r: 2,
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 871,
    cy: 600,
    r: 3.5,
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873,
    cy: 930,
    r: 2.4,
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 913,
    cy: 620,
    r: 2.7,
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 915,
    cy: 910,
    r: 1.9,
    fillOpacity: 0.32
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#168BFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 704,
    cy: 887,
    r: 1.8,
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 717,
    cy: 915,
    r: 2.2,
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728,
    cy: 945,
    r: 1.7,
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 741,
    cy: 876,
    r: 2.4,
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751,
    cy: 908,
    r: 1.6,
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 763,
    cy: 959,
    r: 2.3,
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 772,
    cy: 931,
    r: 1.8,
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 892,
    r: 2,
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 791,
    cy: 915,
    r: 1.5,
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 803,
    cy: 938,
    r: 2.4,
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 812,
    cy: 969,
    r: 1.8,
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 821,
    cy: 881,
    r: 2,
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 831,
    cy: 950,
    r: 1.6,
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842,
    cy: 927,
    r: 2.3,
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 852,
    cy: 961,
    r: 1.7,
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 887,
    r: 2.1,
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 872,
    cy: 946,
    r: 1.5,
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 884,
    cy: 917,
    r: 2.4,
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 894,
    cy: 960,
    r: 1.8,
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 878,
    r: 2,
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 944,
    r: 2.2,
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 914,
    r: 1.6,
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 957,
    r: 1.9,
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 890,
    r: 2.1,
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962,
    cy: 932,
    r: 1.7,
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 681,
    cy: 932,
    r: 1.5,
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 695,
    cy: 958,
    r: 1.8,
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 973,
    cy: 958,
    r: 1.7,
    fillOpacity: 0.22
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSportsDataTrajectories);
export default __webpack_public_path__ + "static/media/hero-sports-data-trajectories.7560467170e3c57c218de24fe06b1e83.svg";
export { ForwardRef as ReactComponent };